module.exports = __webpack_public_path__ + "static/ticinese200-5692256c3177fc6664db8343460e1e0f.png";